import React, { useState } from "react";

import { Row, Col } from "antd";
import Folders from "entities/Folders";
import { useTranslation } from "react-i18next";
import Logo from "shared/components/Logo";
import Space from "shared/components/Space";
import TabItem from "shared/components/TabBar/TabItem";
import ViewControl from "shared/components/ViewControl";
import { NAME_SPACES } from "shared/locals/constants";
import { REPARATION_REQUEST_STATUS, FOLDER_EXTRA_DATA } from "utils/constants";
import { MOBILE_MAX_WIDTH } from "utils/constants";
import useWindowDimensions from "utils/hooks/useWindowDimensions";

import View from "./Folders";
import NoData from "./NoData";
import "./styles.scss";

const Component = () => {
  const [filter, setFilter] = useState({
    where: {
      state: REPARATION_REQUEST_STATUS.OPEN,
      extraData: FOLDER_EXTRA_DATA.ACTIVE_PROCESS,
    },
  });
  const { width } = useWindowDimensions();
  const { t } = useTranslation(NAME_SPACES.FILES);

  return (
    <div className={"products-list"}>
      <Row>
        <ViewControl xs>
          <Logo withDesc={true} width={128} />
          <Space h={24} />
        </ViewControl>
        <Col sm={8} xs={24}>
          <p className={"products-list-title"}>{t("TITLE")}</p>
          <Space sh={24} />
        </Col>
        <Col sm={16} xs={24}>
          <Row justify={width < MOBILE_MAX_WIDTH ? "start" : "end"}>
            <TabItem
              text={`${t("IN_PROGRESS")}`}
              selected={filter.where.state === REPARATION_REQUEST_STATUS.OPEN}
              onClick={() => {
                setFilter({
                  where: { state: REPARATION_REQUEST_STATUS.OPEN },
                });
              }}
              noMargins
            />
            <TabItem
              text={`${t("CLOSED")}`}
              selected={filter.where.state === REPARATION_REQUEST_STATUS.CLOSED}
              onClick={() => {
                setFilter({
                  where: { state: REPARATION_REQUEST_STATUS.CLOSED },
                });
              }}
              noMargin
            />
          </Row>
        </Col>
      </Row>
      <Space h={16} />
      <Folders
        View={View}
        NoData={NoData}
        Error={NoData}
        setFilter={setFilter}
        filter={filter}
      />
    </div>
  );
};

Component.propTypes = {};

export default Component;
